import React from "react"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
const BusinessInfo = ({ data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
      <Typography color="white.main" variant="small">
        {data?.businessAddress}
      </Typography>
      <Link
        href={data?.businessMap}
        color="inherit"
        rel="noopener noreferrer"
        target="_blank"
        className="link-animation"
      >
        <Typography
          sx={{
            textDecoration: "underline",
            textUnderlineOffset: "0.2rem",
            textDecorationColor: "rgba(255, 255, 255, 0.4)",
            "&:hover": { textDecorationColor: "rgba(255, 255, 255, 0.6)" },
          }}
          color="white.main"
          variant="small"
        >
          Get Directions
        </Typography>
      </Link>
    </div>
  )
}
export default BusinessInfo
